import React, { useEffect } from "react";
import { Chat8PerguntasPanelEmptyState } from "./Chat8PerguntasPanelEmptyState";
import { Chat8PerguntasPanelQuestionsList } from "./Chat8PerguntasPanelQuestionsList";
import { Answer } from "../Chat8PerguntasPanel.types";
import { logger } from "@/utils/logger";

interface Chat8PerguntasPanelContentProps {
  isDocumentLoading: boolean;
  shouldRenderQuestions: boolean;
  questions: string[];
  answers: Answer;
  intro: string;
  outro: string;
  freeFormMessage: string;
  isSubmitting: boolean;
  firstAnswerRef: React.RefObject<HTMLTextAreaElement>;
  onAnswerChange: (questionIndex: number, value: string) => void;
  onFreeFormMessageChange: (value: string) => void;
}

export const Chat8PerguntasPanelContent: React.FC<Chat8PerguntasPanelContentProps> = React.memo(
  ({
    isDocumentLoading,
    shouldRenderQuestions,
    questions,
    answers,
    intro,
    outro,
    freeFormMessage,
    isSubmitting,
    firstAnswerRef,
    onAnswerChange,
    onFreeFormMessageChange,
  }) => {
    useEffect(() => {
      logger.info("[Chat8PerguntasPanelContent] 🎯 ESTADO RENDERIZADO:", {
        isDocumentLoading,
        shouldRenderQuestions,
        questionsCount: questions.length,
        timestamp: new Date().toISOString(),
        state: isDocumentLoading ? "LOADING" : shouldRenderQuestions ? "QUESTIONS" : "EMPTY",
      });
    }, [isDocumentLoading, shouldRenderQuestions, questions.length]);

    return (
      <div
        id="chat8-perguntas-content"
        className="chat8-perguntas-content max-h-[45vh] flex-1 overflow-y-auto overflow-x-hidden p-4 bg-navy-800/30 backdrop-blur-sm"
        data-testid="chat8-perguntas-content"
        style={{
          scrollbarWidth: 'thin',
          scrollbarColor: '#1e2835 #0a0e13'
        }}
      >
        {!shouldRenderQuestions ? (
          <Chat8PerguntasPanelEmptyState />
        ) : (
          <Chat8PerguntasPanelQuestionsList
            questions={questions}
            answers={answers}
            intro={intro}
            outro={outro}
            freeFormMessage={freeFormMessage}
            isSubmitting={isSubmitting}
            firstAnswerRef={firstAnswerRef}
            onAnswerChange={onAnswerChange}
            onFreeFormMessageChange={onFreeFormMessageChange}
          />
        )}
      </div>
    );
  }
);

Chat8PerguntasPanelContent.displayName = "Chat8PerguntasPanelContent"; 